<template>
    <div>
<div class="row no-gutters py-2 mb-3 border-bottom ml-3">
                <div class="col-sm-6 pr-3 " >
                <h4 class="atlhr-dashboard-title mt-10">Leave Attendance<span><a v-bind:href="$api_url">Dashboard</a> / Leave Attendance</span></h4>
            </div>                               
            </div>
    <div class="employee-tab-inner custom-card-body bg-wash no-shadow">
        <div class="company-form-container">
            <div class="row no-gutters py-2 mb-3 border-bottom card-header ek_header">
               
                <template  v-if="flg > 0"><div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title"  @click="addNew()">Add New</div></template>
            </div>
            
            <b-overlay :show="showoverlay_list" rounded="sm" class="p-3">
                <div class="mt-0 p-4 rounded-border">    
                                                                
                    <div class="row border-bottom table-head rounded-0">
                        <div class="col-sm text-uppercase py-2 font-weight-bold">
                            Fiscal Year
                        </div>
                        <div class="col-sm text-uppercase py-2 font-weight-bold">
                            Month
                        </div>                    
                        <div class="col-sm text-uppercase py-2 font-weight-bold">
                            Amount
                        </div>
                        <div class="col-sm text-uppercase py-2 font-weight-bold text-right" v-if="flg > 0">    
                            Action                                
                        </div>
                    </div>
                
                    <div class="row border-bottom py-2 hover-bg table-row border-bottom rounded-0" v-for="rfc in rfcs" :key="rfc.id">
                        <div class="col-sm">                    
                            <div class="text-uppercase ">{{rfc.fiscal_year}}</div>
                        </div>
                        <div class="col-sm">                    
                            <div class="text-uppercase ">
                                <template v-for="mnr in months">
                                    <template v-if="mnr.value == rfc.month">{{mnr.text}}</template>
                                </template>
                            </div>
                        </div>
                        <div class="col-sm   ">
                            &#2547 {{rfc.amount}}
                        </div>
                        <div class="col-sm   clearfix" v-if="flg > 0">                                
                            <b-button-toolbar class="float-right" v-if="rfc.flg == 1">
                                <b-button-group class="mr-1">
                                    <b-button title="Edit RFC" @click="editRfc(rfc.id)">
                                        <b-icon icon="wrench" aria-hidden="true" ></b-icon>
                                    </b-button>
                                    <b-button title="Delete RFC" @click="deleteRfc(rfc.id)">
                                        <b-icon icon="trash" aria-hidden="true"></b-icon>
                                    </b-button>
                                </b-button-group>
                            </b-button-toolbar>
                            <div class="text-center float-right mr-4" v-else title="This entry can't be edited or deleted since a payrun has been approved after this was listed." v-b-tooltip placement="right">
                                <b-icon icon="info-circle"></b-icon>
                            </div>
                        </div>
                    </div>                        
                </div>
            </b-overlay>
    
            <b-modal id="bv-modal-example" size="lg" hide-footer title="Rent Free Accommodation">
                <b-form @submit.stop.prevent="onSubmit">                    
                    <div class="clearfix">
                        <div class="col-md-12 mb-4"><div class="col-md-12 border rounded py-2 text-secondary employee-tab-content-title">RFC</div></div>                            
                        
                        <div class="col-md-6 float-left">                           
                            
                            <input type="hidden" v-model="fdata.id" name="id">
                            <b-form-group id="fiscal_year-group" label="Fiscal Year" class="required-field" label-for="fiscal_year">
                                <b-form-input id="fiscal_year" name="fiscal_year" v-model="fdata.fiscal_year" readonly></b-form-input>
                            </b-form-group>
    
    
                            <b-form-group id="month-group" label="Month" class="required-field" label-for="month">
                                <b-form-select id="month" name="month" v-model="fdata.month" :options="months" ></b-form-select>                                    
                            </b-form-group>
                            
                            <b-form-group id="amount-group" label="Amount" class="required-field" label-for="amount">
                                <b-form-input id="amount" name="amount" v-model="fdata.amount" v-validate="{ required: true, min: 3,alpha_spaces: true}" :state="validateState('amount')" aria-describedby="amount-feedback" data-vv-as="Amount"></b-form-input>
                                <b-form-invalid-feedback id="amount-feedback">{{ veeErrors.first('amount') }}</b-form-invalid-feedback>
                            </b-form-group>                                
                        </div>                            
                    </div>
    
                    <div class="mt-4 ml-4 mb-4 clearfix">
                        <b-button class="border rounded float-right py-1 px-5 mt-4 ml-2" type="submit" variant="primary">Submit</b-button>
                        <b-button class="border rounded float-right py-1 px-5 mt-4 ml-2" variant="primary" @click="resetForm()">Reset</b-button>
                    </div>
    
                </b-form>
            </b-modal>
    
        </div>
    </div>
    </div>
</template>
<script>
    export default{
        
        mounted() {
            
            //console.log(this.employee_id);  
        },
        props: ['flg'],
        data(){            
            
            return {                
                itabIndex : 0,
                fiscal_year : this.getCurrentFinancialYear(),
                months: [{ value: 1, text: "January" },{ value: 2, text: "February"},{ value: 3, text: "March"},{ value: 4, text: "April"},{ value: 5, text: "May"},{ value: 6, text: "June"},{ value: 7, text: "July"},{ value: 8, text: "August"},{ value: 9, text: "September"},{ value: 10, text: "October"},{ value: 11, text: "November"},{ value: 12, text: "December", } ],

                rfcs : [], 
                      
                successmsg:null,
                errormsg:[],
                fdata: {fiscal_year : this.getCurrentFinancialYear(), month:1, amount:null, id:null },                   
                
            }
        },
        methods:{
            getRfcs: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
               
                axios.get(this.$api_url+'/front/rfc/list' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.rfcs = response.data;
                    this.tabIndex = 1;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },   
            editRfc:function(x)
            {        
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/front/rfc/details' , {
                    params: {
                        id: x
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    this.successmsg = null;
                    this.$bvModal.show('bv-modal-example');
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
                                
            },           
            
            deleteRfc:function(x)
            {
                if(!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this RFC.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {                    
                    if(value)
                    {                        
                        this.resetForm();
                        this.showoverlay_list = true;
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);
                        
                        axios.post(this.$api_url+'/front/rfc/delete', formData).then(function(response){
                            
                            if(response.data.status == true)
                            {
                                this.successmsg = response.data.meg; 
                                this.$bvToast.toast(response.data.meg, {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                this.getRfcs();                    
                            }
                            this.showoverlay_list = false;                            
                            
                        }.bind(this)).catch(function (error){ currentObj.showoverlay_list = false; currentObj.serverError(error);});   
                    }
                })
            }, 
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
               this.fdata = {fiscal_year: this.getCurrentFinancialYear() , amount:null, id:null};
                
                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            addNew()
            {
                this.resetForm();    
                this.$bvModal.show('bv-modal-example');            
            },
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        //headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();
                                        
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        //console.log(`${key}: ${value}`);
                    } 

                    axios.post(this.$api_url+'/front/rfc/save', formData, config)
                        .then(function (response) 
                        {                                                              
                            this.resetForm();
                            this.getRfcs();
                            this.itabIndex = 1;                              

                            this.$bvToast.toast("Saved", {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                            this.$bvModal.hide('bv-modal-example');
                            
                        }.bind(this))
                        .catch(function (error) 
                        {
                            currentObj.serverError(error);
                            //currentObj.errormsg = error.response.data.errors;
                        });
                });
            },

        },
        created: function(){
            this.getRfcs();
        }
    }
</script>